import { createSelector } from 'reselect';

// State is the application wide state
const dashboard = state => state.modules.dashboard;

export const getDashboardStatus = createSelector(
  dashboard,
  state => state.dashboardStatus
);